import { Link } from "@tanstack/react-router";

import { useNutrients } from "@/lib/api/nutrients";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/error-state";

export function ChemistryNutrientsPage() {
  const q = useNutrients();
  const items = (q.data?.items ?? []).slice().sort((a, b) => {
    if (a.mixing_order_rank !== b.mixing_order_rank) {
      return a.mixing_order_rank - b.mixing_order_rank;
    }
    return a.name.localeCompare(b.name);
  });
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Link to="/chemistry-profile/nutrients/new">
          <Button size="sm">New nutrient</Button>
        </Link>
      </div>
      {q.error && <ErrorState error={q.error} retry={q.refetch} />}
      {q.isLoading && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      {q.data && items.length === 0 && (
        <p className="text-sm text-muted-foreground">No nutrients yet.</p>
      )}
      {items.length > 0 && (
        <ul className="divide-y rounded-md border">
          {items.map((n) => (
            <li key={n.id}>
              <Link
                to="/chemistry-profile/nutrients/$nutrientId"
                params={{ nutrientId: n.id }}
                className="block px-4 py-3 text-sm hover:bg-accent/50"
              >
                <div className="flex items-baseline justify-between gap-4">
                  <div className="space-y-0.5">
                    <p className="font-medium">
                      {n.name}
                      {n.system_provided && (
                        <span className="ml-2 text-[10px] uppercase text-muted-foreground">
                          system
                        </span>
                      )}
                      {n.is_ph_adjuster && (
                        <span className="ml-2 text-[10px] uppercase text-blue-500 dark:text-blue-400">
                          pH adjuster
                        </span>
                      )}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {n.manufacturer || "—"} · order #{n.mixing_order_rank}
                    </p>
                  </div>
                  <div className="text-right text-xs text-muted-foreground tabular-nums">
                    ΔEC/ml/gal {n.delta_ec_per_ml_per_gal ?? "—"}
                    <br />
                    ΔpH/ml/gal {n.delta_ph_per_ml_per_gal ?? "—"}
                  </div>
                </div>
                {(n.contains_calcium ||
                  n.contains_phosphate ||
                  n.is_biological) && (
                  <p className="mt-1 text-[10px] uppercase text-muted-foreground">
                    {[
                      n.contains_calcium && "Ca",
                      n.contains_phosphate && "PO₄",
                      n.is_biological && "biological",
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </p>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
